import { CSSProperties } from 'react'
import { PktButton, PktCard, PktLink } from '..'

export default function Card() {
  const bilde = { src: 'https://cataas.com/cat', alt: 'A random cat' }

  const tekst10Ord = 'En liten axolotl vinker entusiastisk med sine rosa dusker, smilende.'
  const tekst30Ord =
    'Den nysgjerrige pangolinen ruller seg sammen som en krøllete ball mens den kikker rundt med store øyne. En søt quokka danser stille, og en liten narhval synger mykt under månelyset.'
  const tekst75Ord = `Velkommen til den lekne dyrehagen: en liten axolotl glir elegant gjennom vannet, vinker med rosa dusker og sender søte bobler mot overflaten. En nysgjerrig pangolin klatrer forsiktig på stener, mens en lunefull quokka stjeler alles hjerter med sitt uimotståelige smil. I bakgrunnen synger en eventyrlysten narhval en stille serenade under stjernene. Selv den sky fossaen titter frem, vinker forsiktig, og inviterer til en improvisert dans blant glitrende regndråper. En leken tarsier klatrer og fniser forbipasserende.`

  const dyreTekst = [tekst10Ord, tekst30Ord, tekst75Ord]
  const eksotiskeDyr = [
    'Okapi',
    'Numbat',
    'Aye-aye',
    'Axolotl',
    'Quokka',
    'Narhval',
    'Manul',
    'Tarsier',
    'Fossa',
    'Dugong',
    'Pangolin',
    'Kakapo',
    'Saiga antelope',
    'Markhor',
    'Binturong',
    'Kinkajou',
    'Slow Loris',
    'Solenodon',
    'Vaquita',
    'Glass Frog',
    'Leafy Seadragon',
    'Japanese Spider Crab',
    'Aardvark',
    'Bilby',
    'Pink Fairy Armadillo',
  ]
  const soeteDyrekvaliteter = [
    'Store, uttrykksfulle øyne',
    'Myk og luftig pels',
    'Små, runde ører',
    'Knudrete poter',
    'Kort snute',
    'Runde, kompakte kropper',
    'Små vinglete bein',
    'Bustete hale',
    'Høye, spisse ører',
    'Stubbehår',
    'Myk, plussete mage',
    'Lydløse bevegelser',
    'Høye pipelyder',
    'Nysgjerrig utforskning',
    'Vaklende gange',
  ]

  const tilfeldigDyr = () => eksotiskeDyr[Math.floor(Math.random() * eksotiskeDyr.length)]
  const tilfeldigKvalitet = () => soeteDyrekvaliteter[Math.floor(Math.random() * soeteDyrekvaliteter.length)]
  const tilfeldigTekst = () => dyreTekst[Math.floor(Math.random() * dyreTekst.length)]

  // Flex container style
  const flexStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    gap: '2rem 1rem',
    flexWrap: 'nowrap',
    marginBottom: '4rem',
    marginTop: '2rem',
  }

  return (
    <main className="page-main pkt-container">
      {/* Responsive style */}
      <style>{`@media (max-width: 768px) { .flexContainer { flex-direction: column; } }`}</style>

      <h1>Card</h1>
      <div className="component">
        {/* vertical */}
        <section>
          <h2>vertical</h2>
          {/* square */}
          <h3>square</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['outlined-beige', 'blue', 'gray'] as const).map((skin) => (
              <PktCard
                key={`vertical-rect-${skin}`}
                skin={skin}
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
                layout="vertical"
                tagPosition="bottom"
                clickCardLink="/"
              >
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>
          {/* round */}
          SLOTINNHOLD
          <h3>round</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['outlined', 'blue', 'beige'] as const).map((skin) => (
              <PktCard
                key={`vertical-round-${skin}`}
                skin={skin}
                heading={tilfeldigDyr()}
                headingLevel={1}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
                layout="vertical"
                imageShape="round"
                metaTrail="Publisert 12.12.2023"
              >
                <p>{tilfeldigTekst()}</p>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <PktButton skin="primary">Les mer</PktButton>
                  <div style={{ marginTop: '1rem' }}></div>
                  <PktLink iconName="chevron-right" iconPosition="left" href="/">
                    {tilfeldigDyr()}
                  </PktLink>
                </div>
              </PktCard>
            ))}
          </div>
        </section>

        {/* horizontal */}
        <section>
          <h2>horizontal</h2>

          {/* square */}
          <h3>square</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['green', 'gray'] as const).map((skin) => (
              <PktCard
                key={`land-rect-${skin}`}
                skin={skin}
                layout="horizontal"
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
                clickCardLink="/"
              >
                <p>{tilfeldigTekst()}</p>
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>

          {/* round */}
          <h3>round</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['green', 'gray'] as const).map((skin) => (
              <PktCard
                key={`land-round-${skin}`}
                skin={skin}
                layout="horizontal"
                imageShape="round"
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
                metaLead="Pangoline Pangolinesen"
                metaTrail="12.12.2023"
              >
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>
        </section>

        {/* NO PADDING */}
        <section>
          <h2>No Padding</h2>
          <h3>round (horizontal)</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['green', 'gray'] as const).map((skin) => (
              <PktCard
                key={`nopad-land-${skin}`}
                padding="none"
                skin={skin}
                layout="horizontal"
                imageShape="round"
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
              >
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>
          <h3>vertical</h3>
          <div className="flexContainer" style={flexStyle}>
            {(['green', 'gray'] as const).map((skin) => (
              <PktCard
                key={`nopad-por-${skin}`}
                padding="none"
                skin={skin}
                layout="vertical"
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
              >
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>
          <h3>horizontal no padding</h3>
          BAKGRUNNSFARGE
          <div className="flexContainer" style={flexStyle}>
            {(['green', 'gray', 'blue'] as const).map((skin) => (
              <PktCard
                key={`nopad-land2-${skin}`}
                padding="none"
                skin={skin}
                layout="horizontal"
                heading={tilfeldigDyr()}
                subheading={tilfeldigKvalitet()}
                image={bilde}
                tags={[
                  { text: 'Axolotl', skin: 'blue' },
                  { text: 'Quokka', skin: 'blue' },
                  { text: 'Narhval', skin: 'blue' },
                ]}
              >
                <p>{tilfeldigTekst()}</p>
              </PktCard>
            ))}
          </div>
          <h3>horizontal no padding</h3>
          INGEN BAKGRUNNSFARGE
          <div className="flexContainer" style={flexStyle}>
            <PktCard
              padding="none"
              layout="horizontal"
              heading={tilfeldigDyr()}
              subheading={tilfeldigKvalitet()}
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
            >
              <p>{tilfeldigTekst()}</p>
            </PktCard>
          </div>
        </section>

        {/* OPTIONAL PROPS - vertical */}
        <section>
          <h2>Optional props</h2>
          <div className="flexContainer" style={flexStyle}>
            <PktCard
              skin="outlined"
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="vertical"
            />

            <PktCard skin="green" subheading="SubTittel" layout="vertical">
              innhold
            </PktCard>

            <PktCard
              skin="outlined"
              heading={tilfeldigDyr()}
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="vertical"
              style={{ marginBottom: '1rem' }}
            />

            <PktCard
              skin="outlined"
              heading={tilfeldigDyr()}
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="vertical"
              style={{ marginBottom: '1rem' }}
            />
          </div>
        </section>

        {/* OPTIONAL PROPS - horizontal */}
        <section>
          <h2>Optional props - horizontal</h2>
          <div className="flexContainer" style={flexStyle}>
            <PktCard
              skin="blue"
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="horizontal"
              padding="none"
              headingLevel={2}
              style={{ marginBottom: '1rem' }}
            >
              <p>{tilfeldigTekst()}</p>
            </PktCard>

            <PktCard
              skin="blue"
              heading={tilfeldigDyr()}
              subheading={tilfeldigKvalitet()}
              image={bilde}
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="horizontal"
              tagPosition="bottom"
            />

            <PktCard skin="beige" heading="Tittel" layout="horizontal" />

            <PktCard
              skin="blue"
              tags={[
                { text: 'Axolotl', skin: 'blue' },
                { text: 'Quokka', skin: 'blue' },
                { text: 'Narhval', skin: 'blue' },
              ]}
              layout="horizontal"
            >
              <p>{tilfeldigTekst()} </p>
            </PktCard>
          </div>
        </section>
      </div>
    </main>
  )
}
